export const APP_HOME = process.env.PUBLIC_URL
export const SIGN_IN_ROUTE = `${APP_HOME}/sign-in`
export const CATEGORIES_ROUTE = `${APP_HOME}/categories`
export const CATEGORY_MANAGEMENT_ROUTE = `${APP_HOME}/category-management`
